import { Button, makeStyles, Portal } from "@fluentui/react-components";
import React, { useState } from "react";
import { useSidebarContext } from "../SidebarContext";
import { ReactComponent as PortalIcon } from "../icons/Portal.svg";
import PropTypes from "prop-types";

const useClasses = makeStyles({
  portalsButton: {
    "@media (min-width: 992px)": {
      position: "fixed",
      bottom: "20px",
      left: "80px"
    }
  },
  button: {
    height: "40px",
    minWidth: "40px",
    backgroundColor: "var(--toolbar-overlay-background)",
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "var(--colorNeutralForeground1)",
      fill: "currentColor"
    }
  }
});

export function PortalsButton() {
  const { setSidebar } = useSidebarContext();
  const classes = useClasses();

  const handleClick = () => {
    setSidebar("portals");
  };

  return (
    <div className={classes.portalsButton}>
      <Button onClick={handleClick} appearance="subtle" className={classes.button} icon={<PortalIcon />} />
    </div>
  );
}

PortalsButton.propTypes = {
  styles: PropTypes.object
};
